import { Component } from '@angular/core';

@Component({
  template: 'Healthy',
})
export class HealthComponent {}
